import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";

export const PageTitle = styled.h1`
  margin-top: -0.3em;

  && {
    font-size: ${fonts.xLarge};
  }
`;

export const RemitPageFrame = styled.div`
  box-shadow: inset 1px 0 0 ${colours.elexonBlue};
  padding-left: 8px;
`;
